import { baseURL, post, get, put } from './config'

export const isRefresh = true
export const uploadURL = baseURL + '/weapi/v1/uploads'

// export const downloadModel = {
//   'production': '',
//   'development': 'http://192.168.1.186:9903/预算科目模版.xlsx',
//   'lan': 'http://192.168.1.124:8060/预算科目模版.xlsx'
// }[process.env.NODE_ENV]

/* 公共接口 start */

export const uploads = (data) => post(`/weapi/v1/uploads`, data)

/* 公共接口 end */

/**
 * 后台登录
 * @param {*} data
 */
export const login = (data) => post(`/weapi/v1/login`, data)

/**
 * 修改密码
 * @param {*} data
 */
export const chagePw = (data) => put(`/weapi/v1/change`, data)

/* 超管 start */

/**
 * 获取账号列表
 * @param {*} data
 */
export const getAccountList = () => get(`/weapi/v1/users`)

/**
 * 添加后台用户
 * @param {*} data
 */
export const addAccount = (data) => post(`/weapi/v1/user`, data)

/**
 * 更新账号的信息
 * @param {*} id
 */
export const updateAccount = (id, data) => put(`/weapi/v1/user/${id}`, data)

/**
 * 更新账号的状态
 * @param {*} id
 * @param {*} data
 */
export const changeAccountStatus = (id, data) => put(`/weapi/v1/user/${id}/status`, data)

/* 超管 end */

/* 用户管理 start */

/**
 * 获取用户列表
 * @param {*} data
 */
export const getUserList = (data) => get(`/weapi/v1/auth_users`, data)

/**
 * 获取用户的详情
 * @param {*} id
 */
export const getUserDetail = (id) => get(`/weapi/v1/auth_user/${id}`)

/**
 * 获取项目主管
 * @param {*} id
 */
export const getUserStewardList = () => get(`/weapi/v1/users/project_supervisor`)

/**
 * 更改查看状态
 * @param {*} id
 */
export const changeUserLookStatus = (id) => put(`/weapi/v1/auth_user/${id}/status`)

/**
 * 认证用户的修改
 * 只能修改已认证的用户
 * @param {*} id
 */
export const changeUserInfo = (id, data) => put(`/weapi/v1/auth_user/${id}`, data)

/**
 * 认证用户
 * @param {*} id
 */
export const reviewUser = (id, data) => put(`/weapi/v1/auth_user/${id}/review`, data)

/**
 * 驳回用户
 * @param {*} id
 */
export const rejectUser = (id, data) => put(`/weapi/v1/auth_user/${id}/reject`, data)

/* 用户管理 end */

/* 方案管理 start */

/**
 * 获取方案列表
 * 【权限中心主任和项目主管】
 * 【中心主任可以看到已提交、已保存和已完成的方案】
 * 【项目主管可以看到已提交和已完成的方案】
 * @param {*} data
 */
export const getSchemeList = (data) => get(`/weapi/v1/proposals`, data)

/**
 * 获取方案详情
 * @param {*} id
 */
export const getSchemeDetails = (id) => get(`/weapi/v1/proposal/${id}`)

/**
 * 在方案详情中添加课程时
 * 根据类型获所有的课程列表
 */
export const getSchemeCourseList = (data) => get(`/weapi/v1/courses/fetch`, data)

/**
 * 修改方案详情
 * @param {*} id
 * @param {*} data
 */
export const updateSchemeDetails = (id, data) => put(`/weapi/v1/proposal/${id}`, data)

/**
 * 更改方案的查看状态
 * @param {*} id
 */
export const changeSchemeLookStatus = (id) => put(`/weapi/v1/proposal/${id}/status`)

/**
 * 完成方案
 * 将方案的进展状态更改为已完成
 * @param {*} id
 */
export const changeSchemeProcess = (id) => put(`/weapi/v1/proposal/${id}/process`)

/**
 * 创建下载任务
 * @param {*} id
 */
export const createDownloadTask = (id) => post(`/weapi/v1/proposal/${id}/down_task`)

/**
 * 获取任务状态
 * @param {*} id
 */
export const getTaskStatus = (id) => get(`/weapi/v1/proposal/${id}/task_status`)

/**
 * 下载方案文件
 * @param {*} id
 */
export const downloadSchemeFile = (id) => get(`/weapi/v1/proposal/${id}/download`)

/* 方案管理 end */

/* 课程管理 start */

/**
 * 获取课程列表
 * @param {*} data
 */
export const getCourseList = (data) => get(`/weapi/v1/courses`, data)

/**
 * 添加课程详情
 * @param {*} data
 */
export const addCourse = (data) => post(`/weapi/v1/course`, data)

/**
 * 获取课程标签列表
 */
export const getCourseTagsList = (data) => get(`/weapi/v1/courses/tags`, data)

/**
 * 获取课程详情
 * @param {*} id
 */
export const getCourseDetails = (id) => get(`/weapi/v1/course/${id}`)

/**
 * 修改课程状态
 * @param {*} id
 * @param {*} data
 */
export const changeCourseStatus = (id, data) => put(`/weapi/v1/course/${id}/status`, data)

/**
 * 修改课程信息
 * @param {*} id
 * @param {*} data
 */
export const updateCourseDetails = (id, data) => put(`/weapi/v1/course/${id}`, data)

/* 课程管理 end */

/* 教师管理 start */

/**
 * 获取教师列表
 * @param {*} data
 */
export const getTeachersList = (data) => get(`/weapi/v1/teachers`, data)

/**
 * 获取教师详情
 * @param {*} data
 */
export const getTeachersDetails = (id) => get(`/weapi/v1/teacher/${id}`)

/**
 * 编辑教师信息
 * @param {*} id
 */
export const updateTeachersDetails = (id, data) => put(`/weapi/v1/teacher/${id}`, data)

/**
 * 添加教师
 * @param {*} data
 */
export const addTeacher = (data) => post(`/weapi/v1/teacher`, data)

/**
 * 获取教师姓名列表
 * 带有教师的单位和经历
*/
export const getTeacherNameList = () => get(`/weapi/v1/teachers/list`)

/* 教师管理 end */

/* 基本设置 start */

/**
 * 获取基本设置
 */
export const getBaseSetting = () => get(`/weapi/v1/bas_setting`)

/**
 * 修改基本设置
 */
export const updateBaseSetting = (data) => post(`/weapi/v1/bas_setting`, data)

/* 基本设置 end */

/* 酒店管理 start */

/**
 * 获取酒店列表
 * @param {*} data
 */
export const getHotelList = (data) => get(`/weapi/v1/hotels`, data)

/**
 * 获取酒店详情
 * @param {*} id
 */
export const getHotelDetails = (id) => get(`/weapi/v1/hotel/${id}`)

/**
 * 修改酒店状态
 * @param {*} id
 */
export const changeHotelStatus = (id, data) => put(`/weapi/v1/hotel/${id}/status`, data)

/**
 * 新增酒店详情
 * @param {*} data
 */
export const addHotelDetails = (data) => post(`/weapi/v1/hotel`, data)

/**
 * 修改酒店详情
 * @param {*} id
 * @param {*} data
 */
export const updateHotelDetails = (id, data) => put(`/weapi/v1/hotel/${id}`, data)

/* 酒店管理 end */



// WEBPACK FOOTER //
// ./src/api/index.js